import { render, staticRenderFns } from "./DetallePlanPayment.vue?vue&type=template&id=52cda47f&scoped=true&"
import script from "./DetallePlanPayment.vue?vue&type=script&lang=js&"
export * from "./DetallePlanPayment.vue?vue&type=script&lang=js&"
import style0 from "./DetallePlanPayment.vue?vue&type=style&index=0&id=52cda47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cda47f",
  null
  
)

export default component.exports